import request from '@/utils/request'

let ServiceApi = {
  servicelist(data, errorback) {
    return request._post('/supplier/service.service/index', data, errorback);
  },
  addService(data, errorback) {
    return request._post('/supplier/service.service/add', data, errorback);
  },
  getBaseData(data, errorback) {
    return request._get('/supplier/service.service/add', data, errorback);
  },
  changeStatus(data, errorback){
    return request._post('/supplier/service.service/state', data, errorback);
  },
  delService(data, errorback) {
    return request._post('/supplier/service.service/delete', data, errorback);
  },
  getEditData(data, errorback) {
    return request._get('/supplier/service.service/edit', data, errorback);
  },
  editService(data, errorback) {
    return request._post('/supplier/service.service/edit', data, errorback);
  },
  setTechnician(data, errorback) {
    return request._post('/supplier/service.service/setTechnician', data, errorback);
  },
  getServiceTechnician(data, errorback) {
    return request._post('/supplier/service.service/getServiceTechnician', data, errorback);
  },
  /*服务评论列表*/
  getCommentList(data, errorback) {
    return request._post('/supplier/service.comment/index', data, errorback);
  },
  /*获取评论详情*/
  getComment(data, errorback) {
    return request._post('/supplier/service.comment/detail', data, errorback);
  }
}

export default ServiceApi;



// WEBPACK FOOTER //
// ./src/api/service.js